import { PartyUpdateField } from 'generated/gql';
import { t } from '@lingui/macro';

import { formatLegalForm } from './formatLegalForm';
import { formatDate } from './formatShares';

type PartyUpdateFieldObjectProps = {
  [type in PartyUpdateField]: {
    label: () => string;
    formatter: (value: string) => any;
    field: string;
  };
};
export const partyUpdateFieldObject: PartyUpdateFieldObjectProps = {
  [PartyUpdateField.StatutoryName]: {
    label: () => t`Naam`,
    formatter: (value: string) => value,
    field: 'name',
  },
  [PartyUpdateField.IncorporatedOn]: {
    label: () => t`Oprichtingsdatum`,
    formatter: (value: string) => (value ? formatDate(new Date(value)) : ''),
    field: 'incorporatedOn',
  },
  [PartyUpdateField.IncorporatedBy]: {
    label: () => '',
    formatter: (value: string) => value,
    field: 'incorporatedBy',
  },
  [PartyUpdateField.CountryOfRegistration]: {
    label: () => t`Land van registratie`,
    formatter: (value: string) => value,
    field: 'countryOfRegistration',
  },
  [PartyUpdateField.TradeRegisterNumber]: {
    label: () => t`KVK-nummer`,
    formatter: (value: string) => value,
    field: 'tradeRegisterNumber',
  },
  [PartyUpdateField.VisitorAddressStreetName]: {
    label: () => t`Bezoekadres: straatnaam`,
    formatter: (value: string) => value,
    field: 'visitorAddress.streetName',
  },
  [PartyUpdateField.VisitorAddressStreetNumber]: {
    label: () => t`Bezoekadres: huisnummer`,
    formatter: (value: string) => value,
    field: 'visitorAddress.streetNumber',
  },
  [PartyUpdateField.VisitorAddressStreetNumberAddition]: {
    label: () => t`Bezoekadres: toevoeging`,
    formatter: (value: string) => value,
    field: 'visitorAddress.streetNumberAddition',
  },
  [PartyUpdateField.VisitorAddressPostOfficeBoxNumber]: {
    label: () => t`Bezoekadres: toevoeging`,
    formatter: (value: string) => value,
    field: 'visitorAddress.postOfficeBoxNumber',
  },
  [PartyUpdateField.VisitorAddressPostalCode]: {
    label: () => t`Bezoekadres: postcode`,
    formatter: (value: string) => value,
    field: 'visitorAddress.postalCode',
  },
  [PartyUpdateField.VisitorAddressCity]: {
    label: () => t`Bezoekadres: woonplaats`,
    formatter: (value: string) => value,
    field: 'visitorAddress.city',
  },
  [PartyUpdateField.VisitorAddressCountryCode]: {
    label: () => t`Bezoekadres: land`,
    formatter: (value: string) => value,
    field: 'visitorAddress.countryCode',
  },
  [PartyUpdateField.VisitorAddressStreetAndNumber]: {
    label: () => t`Bezoekadres: straat en huisnummer`,
    formatter: (value: string) => value,
    field: 'visitorAddress.streetHouseNumber',
  },
  [PartyUpdateField.VisitorAddressPostalCodeCity]: {
    label: () => t`Bezoekadres: postcode en woonplaats`,
    formatter: (value: string) => value,
    field: 'visitorAddress.postalCodeCity',
  },
  [PartyUpdateField.VisitorAddressRegion]: {
    label: () => t`Bezoekadres: regio`,
    formatter: (value: string) => value,
    field: 'visitorAddress.region',
  },
  [PartyUpdateField.CorrespondenceAddressStreetName]: {
    label: () => t`Correspondentieadres: straatnaam`,
    formatter: (value: string) => value,
    field: 'correspondenceAddress.streetName',
  },
  [PartyUpdateField.CorrespondenceAddressStreetNumber]: {
    label: () => t`Correspondentieadres: huisnummer`,
    formatter: (value: string) => value,
    field: 'correspondenceAddress.streetNumber',
  },
  [PartyUpdateField.CorrespondenceAddressStreetNumberAddition]: {
    label: () => t`Correspondentieadres: toevoeging`,
    formatter: (value: string) => value,
    field: 'correspondenceAddress.streetNumberAddition',
  },
  [PartyUpdateField.CorrespondenceAddressPostOfficeBoxNumber]: {
    label: () => t`Correspondentieadres: toevoeging`,
    formatter: (value: string) => value,
    field: 'correspondenceAddress.postOfficeBoxNumber',
  },
  [PartyUpdateField.CorrespondenceAddressPostalCode]: {
    label: () => t`Correspondentieadres: postcode`,
    formatter: (value: string) => value,
    field: 'correspondenceAddress.postalCode',
  },
  [PartyUpdateField.CorrespondenceAddressCity]: {
    label: () => t`Correspondentieadres: woonplaats`,
    formatter: (value: string) => value,
    field: 'correspondenceAddress.city',
  },
  [PartyUpdateField.CorrespondenceAddressCountryCode]: {
    label: () => t`Correspondentieadres: land`,
    formatter: (value: string) => value,
    field: 'correspondenceAddress.countryCode',
  },
  [PartyUpdateField.CorrespondenceAddressStreetAndNumber]: {
    label: () => t`Correspondentieadres: straat en huisnummer`,
    formatter: (value: string) => value,
    field: 'correspondenceAddress.streetHouseNumber',
  },
  [PartyUpdateField.CorrespondenceAddressPostalCodeCity]: {
    label: () => t`Correspondentieadres: postcode en woonplaats`,
    formatter: (value: string) => value,
    field: 'correspondenceAddress.postalCodeCity',
  },
  [PartyUpdateField.CorrespondenceAddressRegion]: {
    label: () => t`Correspondentieadres: regio`,
    formatter: (value: string) => value,
    field: 'correspondenceAddress.region',
  },
  [PartyUpdateField.RsinNumber]: {
    label: () => t`RSIN`,
    formatter: (value: string) => value,
    field: 'rsinNumber',
  },
  [PartyUpdateField.EmailAddresses]: {
    label: () => t`E-mailadres`,
    formatter: (value: string) => value,
    field: 'emailAddress',
  },
  [PartyUpdateField.PhoneNumber]: {
    label: () => t`Telefoonnummer`,
    formatter: (value: string) => value,
    field: 'phoneNumber',
  },
  [PartyUpdateField.LegalForm]: {
    label: () => t`Rechtsvorm`,
    formatter: (legalForm: string) => formatLegalForm({ legalForm }),
    field: 'legalForm',
  },
  [PartyUpdateField.RegisteredOn]: {
    label: () => t`Datum inschrijving KVK`,
    formatter: (value: string) => (value ? formatDate(new Date(value)) : ''),
    field: 'registeredOn',
  },
};
